import { AsyncResponse, sendAsyncAction } from "@/core/async";


export enum UserGraphicsQualityPresetTypes {
    LOW = 'low',
    MEDIUM = 'medium',
    HIGH = 'high',
}

export interface UserGraphicsQuality {
    hardware: {
        cpu_score: number;
        cpu_memory: number; 
        gpu_score: number;
        gpu_memory: number;
    }, 
    settings: {
        web_browser_hardware_acceleration: true,
        low_quality_gui: false,
        contrast_ui: false,
        colorblind_mode: false
    },
}

export interface UserGraphicsQualityPreset extends UserGraphicsQuality {
    preset: UserGraphicsQualityPresetTypes;
}

export const PRESET_BY_CODE: Record<number, UserGraphicsQualityPresetTypes> = {
    2: UserGraphicsQualityPresetTypes.HIGH,
    1: UserGraphicsQualityPresetTypes.MEDIUM,
    0: UserGraphicsQualityPresetTypes.LOW,
}

export function getCodeCpuScore(cpuScore: number) {
    if (cpuScore >= 600000) {
        return 2;
    }
    if (cpuScore < 600000 && cpuScore >= 250000) {
        return 1;
    }
    return 0;
}

export function getCodeGpuScore(gpuScore: number) {
    if (gpuScore >= 5800) {
        return 2;
    }
    if (gpuScore < 5800 && gpuScore >= 1600) {
        return 1;
    }
    return 0;
}

// https://jira.wargaming.net/browse/WSCLANS-7391
export function getUserGraphicsQualityPreset(): Promise<AsyncResponse<UserGraphicsQualityPreset>> {
    return sendAsyncAction({ actionId: "getHardwareAndUiQualitySettings" }).then((response) => {
        const { settings, hardware } = response.data as UserGraphicsQuality;
        const isLowBySettings = settings.low_quality_gui || !settings.web_browser_hardware_acceleration;

        if (isLowBySettings) {
            response.data.preset = UserGraphicsQualityPresetTypes.LOW;
        } else {
            response.data.preset = PRESET_BY_CODE[Math.min(...[getCodeCpuScore(hardware.cpu_score), getCodeGpuScore(hardware.gpu_score)])];
        }

        return response;
    });
}